export const NOTIFICATION_TABS = [
  { id: "webhooks", label: "Webhook Registry" },
  { id: "notifications", label: "Notification Settings" },
  { id: "lexai", label: "LexAI Services" },
  { id: "logs", label: "Event Logs" }
];

export const inputBaseClass =
  "w-full border border-gray-300 rounded-md px-3 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 bg-white outline-none focus:ring-2 focus:ring-blue-500/30 focus:border-blue-500";

export const btnPrimaryClass =
  "inline-flex items-center gap-2 px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700";

export const btnSecondarySmClass =
  "inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium rounded-md border border-gray-300 bg-gray-50 hover:bg-gray-100";

export const btnSecondaryClass =
  "inline-flex items-center px-4 py-2 rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50";
